
import AppImage from '@/components/core/AppImage';
import AppVideo from '@/components/core/AppVideo';
import AppReviewMedium from '@/components/common/AppReviewMedium';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationSizeFeedbackCard',
  name: 'SizeRecommendationSizeFeedbackCard',
  components: { AppImage, AppVideo, AppReviewMedium },
  props: {
    feedback: { type: Object, required: true },
    expanded: { type: Boolean, default: false }
  },
  computed: {
    measurements() {
      return [this.feedback.height, this.feedback.weight]
        .filter(Boolean)
        .join('/');
    }
  }
};
